<template>
  <div name="max">
    <div class="w-95p mx-auto pb-10 grid md:grid-cols-2 grid-cols-1 space-x-6">
      <div>
          <img class="opacity-75" src="/static/images/dance.png" alt="" />
      </div>

      <div>
        <h3 class="text-lg font-bold mb-2">
           Dance is a creative and physical activity that develops students' coordination, creativity, and social skills while supporting their emotional well-being.
        </h3>

        <p class="mb-2">
        
           It can be integrated into the physical education curriculum and taught through structured lessons that often involve responding to stimuli like music or stories, working in groups, and creating their own choreography<br/>
  Our features include tailored CPD and rich resources for unleashing every child's
          potential.
        </p>
        <p>
Dance improves coordination, flexibility, and strength through movement whilst providing a creative outlet for children to express ideas and emotions through movement.<br/>
It can also be used to encourage teamwork, communication, and cooperation through group activities.
        </p>

        <div class="my-5" v-if="shouldShowUpgrade">
          <p class="font-semibold">
            Register your interest below to get further information about our Dance features and content, including our bespoke Dance CPD content which will assist teachers and schools in their Dance provision.
          </p>

          <div class="flex justify-between text-center w-5/12  mt-6" v-if="!registerComplete">
            <button
              @click="registerInterest()"
              class="block bg-blue-500 bg-opacity-75 hover:bg-opacity-50 focus:bg-action-blue focus:bg-opacity-50 text-white font-semibold rounded py-3 px-4"
            >
              Register my interest
            </button>

            <button
              @click="registerSignUp()"
              class="block bg-orange-500 bg-opacity-75 hover:bg-opacity-50 focus:bg-action-blue focus:bg-opacity-50 text-white font-semibold rounded py-3 px-4"
            >
              Sign school up now!
            </button>
          </div>

          <p class="text-green-500 font-bold mt-2" v-else>
            Thank you for registering your interest. <br />One of our team will
            be in touch.
          </p>
        </div>

      </div>
    </div>

    <ModalSlide
        :show="showBoard"
        :headCss="'bg-opacity-25'"
        @closeModal="cancel()"
      >
      <template v-slot:header-icon>
        <i class="fas fa-bell"></i>
      </template>
        <template v-slot:header-title>
            <h2 class="text-xl font-bold">{{ typeTitle }}</h2>
        </template>
        <template v-slot:body>

            <p class="p-4" v-if="selectedType === 'signup'">Thank you for expressing an interest in signing up to our Dance feature. <br/>
            Should you proceed, one of our team will be in touch and the Dance feature will be activated within your account in the next 24 hours. <br/>
            A corresponding invoice will be sent to your school admin contact.</p>

            <p class="p-4" v-else>Thank you for expressing an interest in signing up to Dance feature. <br/>
            Should you proceed, one of our team will be in touch to discuss details.</p>

            <div class="flex flex-wrap mx-3 mb-4">
              <div class="w-full">
                <label class="form-label" for="grid-title">
                  Contact Name
                </label>
                <input
                  v-model="contactName"
                  class="p-2 mb-2 focus:border-red-200 focus:bg-white focus:outline-none"
                  id="grid-title"
                  type="text"
                  placeholder="Enter title"
                  required
                />
                <p class="text-red-300 text-xs italic">
                  Please fill out this field.
                </p>
              </div>
            </div>
            <div class="flex flex-wrap mx-3 mb-8">
              <div class="w-full">
                <label class="form-label" for="grid-title">
                  Contact Email
                </label>
                <input
                  v-model="contactEmail"
                  class="p-2 mb-2 focus:border-red-200 focus:bg-white focus:outline-none"
                  id="grid-title"
                  type="text"
                  placeholder="Enter title"
                  required
                />
                <p class="text-red-300 text-xs italic">
                  Please fill out this field.
                </p>
              </div>
            </div>

            <div class="flex mx-auto w-8/12 p-2 space-x-4 pb-4">
                  <button
                    @click="processInterest()"
                    class="publish-button hover:opacity-75 w-full cursor-pointer bg-green-400 py-3"
                  >
                   Yes, please continue
                  </button>
                  <button
                    @click="cancel()"
                    class="publish-button hover:opacity-75 w-full cursor-pointer bg-red-400 py-2"
                  >
                    Cancel
                  </button>
                </div>
          
        </template>
      </ModalSlide>


  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SchoolService } from "@/services/school.service";
import { upgradeMixin } from "@/mixins/upgradeMixin.js";

const ModalSlide = () => import("@/components/ModalSlide.vue");

export default {
  name: "max",
  props: [],
     mixins: [upgradeMixin],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    showForSchool() {
      return this.currentUser.isSchool == true;
    },
    typeTitle() {
      return this.selectedType === 'login' ? "Signup to Dance" : "Register my interest"
    }
  },
  data() {
    return {
      registerComplete: false,
      showBoard: false,
      selectedType: null,
      contactName: "",
      contactEmail: "",
    };
  },
  created() {},
  mounted() {},
  methods: {
    completion() {
      this.registerComplete = true;
      this.selectedType = null 
      this.showBoard = false
    },
    registerInterest() {
      this.selectedType = "interest"
      this.showBoard = true
    },
    registerSignUp() {
      this.selectedType = "signup"
      this.showBoard = true
    },
    processInterest() {
      let result =  "Dance \nType: " + this.selectedType + "\nContact: " + this.contactName + "\nEmail: " + this.contactEmail
      let payload = { content: result };
      SchoolService.create("comms/feature-request", payload)
        .then((response) => this.completion())
        .catch((err) => {
          this.cancel();
          console.log("Reset error " + err);
        });
    },
    cancel() {
      this.selectedType = null 
      this.showBoard = false
    }
  },
  components: {
    ModalSlide
  },
};
</script>

<style scoped>
</style>